
export default {
    name: 'recommend',
    props: ['source'],
    data() {
        return {


        }
    },
    mounted() {

    },
    methods: {

    }
}
